import { useMemo, useState } from 'react';
import { ReactSimpleComponentProps } from '@/custom-types';
import { ShowGalleryPictureModalContext, ShowGalleryPictureModalContextProps } from './ShowGalleryPictureModalContext';

export const ShowGalleryPictureModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
  const [pictures, setPictures] = useState<File[]>([])
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<ShowGalleryPictureModalContextProps, 'pictures' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
    },

    openModal: (newPictures: File[]) => {
      setOpen(true)
      setPictures(newPictures)
    },
  }), [])

  return (
    <ShowGalleryPictureModalContext.Provider value={{ ...actions, isOpen, pictures }}>
      {children}
    </ShowGalleryPictureModalContext.Provider>
  )
}